import { createClient } from "@/lib/supabase/client";
import type { AdminNotificationsPage } from "@/types/admin-notifications";

/** GET /api/notifications/unread-count — replaced by get_notifications_unread_meta */
export async function fetchNotificationsUnreadMeta(): Promise<{
  unreadCount: number;
  lastViewedAt: string | null;
}> {
  const supabase = createClient();
  const { data, error } = await supabase.rpc("get_notifications_unread_meta");
  if (error) throw error;
  const row = data as { unreadCount?: number; lastViewedAt?: string | null } | null;
  return {
    unreadCount: row?.unreadCount ?? 0,
    lastViewedAt: row?.lastViewedAt ?? null,
  };
}

/** Admin infinite list — get_admin_notifications_page */
export async function fetchAdminNotificationsPageRpc(params: {
  limit: number;
  offset: number;
  /** From resolveTypeQueryToDbVariants; null = no type filter */
  p_types: string[] | null;
  p_is_read: boolean | null;
  p_user_id: string | null;
}): Promise<AdminNotificationsPage> {
  const supabase = createClient();
  const { data, error } = await supabase.rpc("get_admin_notifications_page", {
    p_limit: params.limit,
    p_offset: params.offset,
    p_types: params.p_types,
    p_is_read: params.p_is_read,
    p_user_id: params.p_user_id,
  });
  if (error) throw error;

  const raw = data as {
    notifications?: unknown;
    hasMore?: boolean;
    nextOffset?: number;
    total?: number;
    limit?: number;
    offset?: number;
    totalUnread?: number | null;
  } | null;

  const notifications = (raw?.notifications as AdminNotificationsPage["notifications"]) ?? [];
  return {
    notifications,
    hasMore: Boolean(raw?.hasMore),
    nextOffset: typeof raw?.nextOffset === "number" ? raw.nextOffset : params.offset,
    total: typeof raw?.total === "number" ? raw.total : undefined,
    limit: typeof raw?.limit === "number" ? raw.limit : params.limit,
    offset: typeof raw?.offset === "number" ? raw.offset : params.offset,
    totalUnread:
      raw?.totalUnread === null || raw?.totalUnread === undefined
        ? undefined
        : Number(raw.totalUnread),
  };
}

export async function adminSetNotificationReadRpc(id: string, isRead: boolean): Promise<void> {
  const supabase = createClient();
  const { error } = await supabase.rpc("admin_set_notification_read", {
    p_id: id,
    p_is_read: isRead,
  });
  if (error) throw error;
}

export async function adminMarkAllNotificationsReadRpc(): Promise<number> {
  const supabase = createClient();
  const { data, error } = await supabase.rpc("admin_mark_all_notifications_read");
  if (error) throw error;
  const row = data as { updated?: number } | null;
  return row?.updated ?? 0;
}
